// @ts-ignore
import {TimeReportIsBillableFilter} from "../../../views/reports/time-reports/@types";
import {ExportGrouping} from "../../gd/const/import-export/export-const";

const modalComponentLoaderFunction = () => import(/* webpackChunkName: "export-time-reports" */ '../../../core/modules/import-export/export-time-reports/components/modal/export-to-csv-time-reports')

// @ts-ignore
const modalExportPngLoaderFunction = () => import(/* webpackChunkName: "export-modal" */ './png/export-to-png')
// @ts-ignore
const modalExportPdfLoaderFunction = () => import(/* webpackChunkName: "export-modal" */ './pdf/export-to-pdf')

export default class ExportModalsManager {

    exportTimeReports(
        companyId           : ID,
        dateRange           : MomentRange,
        groupByType         : any = ExportGrouping.BY_TASK,
        projectId           : ID | null,
        userId              : ID | null,
        guesstimates        : boolean,
        taskTypeIds         : any = null,
        isBillableFilter    : TimeReportIsBillableFilter = TimeReportIsBillableFilter.ALL) {

        gd.modal.loadAndShow(modalComponentLoaderFunction, 'export-to-csv-time-reports', {
            modalType   : 'v4',
            params      : {
                companyId,
                dateRange,
                groupByType,
                projectId,
                userId,
                guesstimates,
                taskTypeIds,
                isBillableFilter,

                onSubmit: () => {gd.modal.hide()},
            }
        })
    }

    exportToPng(options?:any) {
        gd.modal.loadAndShow(modalExportPngLoaderFunction, 'modal-export', {
            modalType: 'v4',
            params: {
                dateRange       : _.get(options, 'dateRange', false),
                dateRangeLimits : _.get(options, 'dateRangeLimits', false),
            }
        });
    }

    exportToPdf(options:any) {
        gd.modal.loadAndShow(modalExportPdfLoaderFunction, 'modal-export', {
            modalType: 'v4',
            params: {
                app             : _.get(options, 'app', false),
                dateRange       : _.get(options, 'dateRange', false),
                dateRangeLimits : _.get(options, 'dateRangeLimits', false),
                exportComponent : _.get(options, 'exportComponent', false),
            }
        });
    }

}
